import BackboneElement from './BackboneElement';
import Reference from './types/Reference';
import merge from 'lodash/merge';

export default class HealthcareServicePerDiemApplicableServices extends BackboneElement {
    static __className = 'HealthcareServicePerDiemApplicableServices';

    __objectStructure = {
        service: Reference,
        code: String,
        units: Number,
    };

    constructor(constructJson, className = 'HealthcareServicePerDiemApplicableServices') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
